module.exports = __webpack_public_path__ + "img/02.92518904.svg";